// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"d9e31328","164":"2e872717","263":"19234f57","342":"45f8b86b","426":"b0b24a39","488":"1446b851","603":"9acd3d11","749":"0e953304","911":"34d5710b","962":"ee93ddf6"}[chunkId] + ".chunk.js";
};